//#region Imports
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { AccordionModule } from 'primeng/accordion';
import { TreeTableModule } from 'primeng/treetable';
import { CheckboxModule } from 'primeng/checkbox';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { SliderModule } from 'primeng/slider';
import { RadioButtonModule } from 'primeng/radiobutton';
import { PanelModule } from 'primeng/panel';
import { FieldsetModule } from 'primeng/fieldset';
import { CardModule } from 'primeng/card';
import { OrderListModule } from 'primeng/orderlist';
import { FileUploadModule } from 'primeng/fileupload';
import { StepsModule } from 'primeng/steps';
import { ToastModule } from 'primeng/toast';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputNumberModule } from 'primeng/inputnumber';
import { TabViewModule } from 'primeng/tabview';
import { CalendarModule } from 'primeng/calendar';
import { ToolbarModule } from 'primeng/toolbar';
import {ListboxModule} from 'primeng/listbox';
import {KnobModule} from 'primeng/knob';
import { ChartModule } from 'primeng/chart';
import { KeyFilterModule } from 'primeng/keyfilter';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TagModule } from 'primeng/tag';
//#endregion Imports


export const PrimeNgModules: any[] = [
  TableModule,
  InputTextModule,
  DropdownModule,
  ButtonModule,
  DialogModule,
  MultiSelectModule,
  AccordionModule,
  TreeTableModule,
  CheckboxModule,
  TooltipModule,
  ConfirmDialogModule,
  ToggleButtonModule,
  SliderModule,
  RadioButtonModule,
  PanelModule,
  FieldsetModule,
  CardModule,
  OrderListModule,
  FileUploadModule,
  ToastModule,
  MessagesModule,
  MessageModule,
  StepsModule,
  InputTextareaModule,
  InputSwitchModule,
  InputNumberModule,
  TabViewModule,
  CalendarModule,
  ToolbarModule,
  ListboxModule,
  KnobModule,
  ChartModule,
  KeyFilterModule,
  TagModule,
  AutoCompleteModule
];

//#region Exports All Module
export * from 'primeng/table';
export * from 'primeng/inputtext';
export * from 'primeng/dropdown';
export * from 'primeng/button';
export * from 'primeng/dialog';
export * from 'primeng/multiselect';
export * from 'primeng/accordion';
export * from 'primeng/treetable';
export * from 'primeng/checkbox';
export * from 'primeng/tooltip';
export * from 'primeng/confirmdialog';
export * from 'primeng/fileupload';
export * from 'primeng/messages';
export * from 'primeng/message';
export * from 'primeng/steps';
export * from 'primeng/toast';
export * from 'primeng/inputtextarea';
export * from 'primeng/inputswitch';
export * from 'primeng/inputnumber';
export * from 'primeng/tabview';
export * from 'primeng/calendar';
export * from 'primeng/toolbar';
export * from 'primeng/listbox';
export * from 'primeng/knob';
export * from 'primeng/chart';
export * from 'primeng/keyfilter';
export * from 'primeng/tag';
export * from  'primeng/autocomplete';
//#endregion Exports All Module
